import { IonGrid, IonRow } from "@ionic/react";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";

import BlockAccordion from "@components/accordions/BlockAccordion";
import ResourceFeature from "@components/ResourceFeature";
import useMyExpert from "@hooks/useMyExpert";
import { ResourceFragment } from "@typing/Generated";
import { sortByPosition } from "@utils/modelUtils";

type Props = {
  journeyId: string;
  resource: ResourceFragment;
};

const ResourceFeatures = ({ journeyId, resource }: Props) => {
  const myExpert = useMyExpert();

  const orderedFeatures = useMemo(() => {
    const orderedFiltered = sortByPosition(resource.task.resourceFeatures).filter(
      feature => myExpert || resource.featureValues.some(fv => fv.resourceFeature.id === feature.id)
    );
    return orderedFiltered.map(feature => ({
      featureValue: resource.featureValues.find(fv => fv.resourceFeature.id === feature.id),
      resourceFeature: feature
    }));
  }, [myExpert, resource.featureValues, resource.task.resourceFeatures]);

  if ((myExpert && orderedFeatures.length > 0) || resource.featureValues.length > 0) {
    return (
      <div className="ion-margin-bottom">
        <BlockAccordion
          color="white"
          content={
            <IonGrid className={`ion-no-padding ion-no-margin`}>
              <IonRow className="ion-no-padding ion-no-margin">
                {orderedFeatures.map(featureData => (
                  <ResourceFeature
                    journeyId={journeyId}
                    key={featureData.featureValue?.id}
                    resource={resource}
                    resourceFeature={featureData.resourceFeature}
                    resourceFeatureValue={featureData.featureValue}
                  />
                ))}
              </IonRow>
            </IonGrid>
          }
          heading={<FormattedMessage id="pages.carePlan.task.resources.viewFeatures" />}
        />
      </div>
    );
  }

  return null;
};

export default ResourceFeatures;
